<template>
    <div>
      <div style="padding-top:30px;">
        <div class="page-titles p-3 border-bottom">
          <button class="btn btn-info btn-sm pull-right" @click="$router.push('/account/users/general-partners')"><i class="fas fa-list"></i> <span class="d-none d-sm-inline">General partners</span></button>
            <h3 class="text-themecolor">Campaign setup ({{ user.profile.first_name+' '+user.profile.last_name }})</h3>
        </div>
        <div class="container-fluid p-20" style="font-size: 0.75em;">
            <div class="row">
                <div class="col-12">
                    <button @click.prevent="saveUserCampaign" v-if="(view=='emails' || view=='settings') && !is_started" class="btn btn-info btn-sm pull-right" style="margin-top:-20px;"><i class="fas fa-save"></i> &nbsp; <span class="d-none d-sm-inline">Save and continue</span></button>
                    <button @click.prevent="saveUserCampaignInvestors" v-if="view=='investors' && !is_started" class="btn btn-info btn-sm pull-right" style="margin-top:-20px;"><i class="fas fa-play"></i> &nbsp; <span class="d-none d-sm-inline">Start campaign</span></button>
                    <ul class="pta-campaign-steps">
                      <li :class="view=='emails'?'active':''">Emails</li>
                      <li :class="view=='settings'?'active':''">Settings</li>
                      <li :class="view=='investors'?'active':''">Investors</li>
                    </ul>
                    <div class="card">
                        <div class="card-body" v-if="view=='investors' && !is_started">
                          <div v-if="!is_loaded">Data is loading ...</div>
                          <div v-else>
                            <div class="table-responsive" v-if="investors.length">
                              <div class="table-responsive" v-if="investors.length">
                                <div class="pta-investor-selection" style="font-size:24px;">
                                  <table class="table table-hover" style="max-width:100%;">
                                    <thead>
                                    <tr>
                                      <th></th>
                                      <th>Organisation</th>
                                      <th>Contact&nbsp;Person</th>
                                      <!-- <th>Investor&nbsp;Type</th>
                                      <th>Preferred Asset Class</th>
                                      <th>Preferred Geographic Area</th> -->
                                      <th class="table-option">Mail-Preview</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="investor in investors" v-if="investors && investor.name" :class="investor.pivot.is_deactive==2?'pta-investor-deactivated':''">
                                      <td valign="top"><input type="checkbox" @click="updateInvestorStatus(investor.id, investor.pivot.is_deactive)" :value="investor.id" :checked="investor.pivot.is_deactive==2?false:true" /></td>
                                      <td valign="top" v-html="investor.name"></td>
                                      <td valign="top" v-html="investor.contact_person"></td>
                                      <td class="table-option">
                                        <div class="btn-group" v-if="is_confirmed">
                                          <button class="btn btn-info btn-sm" @click.prevent="showMessage(investor.id)" v-tooltip="'Message preview'"><i class="fas fa-envelope"></i></button>
                                        </div>
                                      </td>
                                     <!-- <td valign="top">
                                        <span v-for="investor_type in investor.investor_types">{{investor_type}}</span>
                                      </td>
                                      <td valign="top">
                                        <span v-for="asset_class in investor.asset_classes">{{asset_class}}</span>
                                      </td>
                                      <td valign="top">
                                        <span v-for="geo in investor.geos">{{geo}}</span>
                                      </td> -->
                                    </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                              <div v-else>No investors connected.</div>
                              </div>
                          </div>
                      </div>
                      <div class="card-body" v-else-if="view=='emails' && is_loaded && !is_started">

                        <div class="pta-campaign-email">
                          <div class="form-group">
                            <label for="">Email 1</label>
                            <input class="form-control" type="text" value="" v-model="templateForm.message_1_subject" name="message_1_subject">
                            <show-error :form-name="templateForm" prop-name="message_1_subject"></show-error>
                          </div>
                          <div class="form-group">
                            <autosize-textarea v-model="templateForm.message_1_body" rows="20" name="message_1_body"></autosize-textarea>
                            <!-- <html-editor name="body" :model.sync="templateForm.body" isUpdate="true" @clearErrors="templateForm.errors.clear('body')"></html-editor> -->
                            <show-error :form-name="templateForm" prop-name="message_1_body"></show-error>
                          </div>
                        </div>

                        <div class="pta-campaign-email">
                          <div class="form-group">
                            <label for="">Email 2</label>
                            <input class="form-control" type="text" value="" v-model="templateForm.message_2_subject" name="message_2_subject">
                            <show-error :form-name="templateForm" prop-name="message_2_subject"></show-error>
                          </div>
                          <div class="form-group">
                            <autosize-textarea v-model="templateForm.message_2_body" rows="20" name="message_2_body"></autosize-textarea>
                            <!-- <html-editor name="body" :model.sync="templateForm.body" isUpdate="true" @clearErrors="templateForm.errors.clear('body')"></html-editor> -->
                            <show-error :form-name="templateForm" prop-name="message_2_body"></show-error>
                          </div>
                        </div>

                        <div class="pta-campaign-email">
                          <div class="form-group">
                            <label for="">Email 3</label>
                            <input class="form-control" type="text" value="" v-model="templateForm.message_3_subject" name="message_3_subject">
                            <show-error :form-name="templateForm" prop-name="message_3_subject"></show-error>
                          </div>
                          <div class="form-group">
                            <autosize-textarea v-model="templateForm.message_3_body" rows="20" name="message_3_body"></autosize-textarea>
                            <!-- <html-editor name="body" :model.sync="templateForm.body" isUpdate="true" @clearErrors="templateForm.errors.clear('body')"></html-editor> -->
                            <show-error :form-name="templateForm" prop-name="message_3_body"></show-error>
                          </div>
                        </div>

                        <div class="pta-campaign-email">
                          <div class="form-group">
                            <label for="">Email 4</label>
                            <input class="form-control" type="text" value="" v-model="templateForm.message_4_subject" name="message_4_subject">
                            <show-error :form-name="templateForm" prop-name="message_4_subject"></show-error>
                          </div>
                          <div class="form-group">
                            <autosize-textarea v-model="templateForm.message_4_body" rows="20" name="message_4_body"></autosize-textarea>
                            <!-- <html-editor name="body" :model.sync="templateForm.body" isUpdate="true" @clearErrors="templateForm.errors.clear('body')"></html-editor> -->
                            <show-error :form-name="templateForm" prop-name="message_4_body"></show-error>
                          </div>
                        </div>

                        <div class="pta-campaign-email">
                          <div class="form-group">
                            <label for="">Email 5</label>
                            <input class="form-control" type="text" value="" v-model="templateForm.message_5_subject" name="message_5_subject">
                            <show-error :form-name="templateForm" prop-name="message_5_subject"></show-error>
                          </div>
                          <div class="form-group">
                            <autosize-textarea v-model="templateForm.message_5_body" rows="20" name="message_5_body"></autosize-textarea>
                            <!-- <html-editor name="body" :model.sync="templateForm.body" isUpdate="true" @clearErrors="templateForm.errors.clear('body')"></html-editor> -->
                            <show-error :form-name="templateForm" prop-name="message_5_body"></show-error>
                          </div>
                        </div>

                      </div>
                      <div class="card-body" v-else-if="view=='settings' && !is_started">
                        <h3>Email sending</h3>
                        <label>Sending interval: </label>
                        <select v-model="templateForm.sending_interval">
                          <option value="1">1 day</option>
                          <option value="2" selected>2 days</option>
                          <option value="5">5 days</option>
                          <option value="10">10 days</option>
                        </select>
                      </div>
                      <div class="card-body" v-else-if="is_started">
                        <h3>Campaign is running</h3>
                      </div>
        </div>
                </div></div></div>
      </div>


      <div id="modalMessage" class="modal fade">
        <div class="modal-dialog" style="max-width:920px;">
          <div class="modal-content">
            <div class="modal-header" style="display:block;">
              <button type="button" class="close" data-dismiss="modal"><span aria-hidden="true">×</span> <span class="sr-only">close</span></button>
              <h4 id="modalTitle" class="modal-title">Message preview ({{ cur_message_name }})</h4>
            </div>
            <div id="modalBody" class="modal-body" style="font-size:18px;line-height:24px;"><!--   -->

              <div
                  id='carouselExampleIndicators'
                  class='carousel slide'
                  data-ride='carousel'
              >
                <ol class='carousel-indicators'>
                  <li
                      data-target='#carouselExampleIndicators'
                      data-slide-to='0'
                      class='active'
                      @click='onSlide(0)'
                  ></li>
                  <li
                      data-target='#carouselExampleIndicators'
                      data-slide-to='1'
                      @click='onSlide(1)'
                  ></li>
                  <li
                      data-target='#carouselExampleIndicators'
                      data-slide-to='2'
                      @click='onSlide(2)'
                  ></li>
                  <li
                      data-target='#carouselExampleIndicators'
                      data-slide-to='3'
                      @click='onSlide(3)'
                  ></li>
                  <li
                      data-target='#carouselExampleIndicators'
                      data-slide-to='4'
                      @click='onSlide(4)'
                  ></li>
                </ol>
                <div class='carousel-inner' v-if="messages[0]">
                  <div class='carousel-item active' v-html="messages[0].message"></div>
                  <div class='carousel-item' v-html="messages[1].message"></div>
                  <div class='carousel-item' v-html="messages[2].message"></div>
                  <div class='carousel-item' v-html="messages[3].message"></div>
                  <div class='carousel-item' v-html="messages[4].message"></div>
                </div>
                <a
                    class='carousel-control-prev'
                    href='#carouselExampleIndicators'
                    role='button'
                    data-slide='prev'
                    @click="onSlidePrev"
                >
                  <span class='carousel-control-prev-icon' aria-hidden='true'></span>
                  <span class='sr-only'>Previous</span>
                </a>
                <a
                    class='carousel-control-next'
                    href='#carouselExampleIndicators'
                    role='button'
                    data-slide='next'
                    @click="onSlideNext"
                >
                  <span class='carousel-control-next-icon' aria-hidden='true'></span>
                  <span class='sr-only'>Next</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>


</div>
</template>
<script>
import htmlEditor from '../../components/html-editor'
import autosizeTextarea from '../../components/autosize-textarea'
    export default {
      components : { autosizeTextarea},
        data() {
            return {
               id:this.$route.params.id,
               user: {
                 profile: {
                   first_name: '',
                   last_name: ''
                 },
                 investors: []
               },
              templateForm: new Form({
                user_id: this.id,
                message_1_subject:'',
                message_1_body:'',
                message_2_subject:'',
                message_2_body:'',
                message_3_subject:'',
                message_3_body:'',
                message_4_subject:'',
                message_4_body:'',
                message_5_subject:'',
                message_5_body:'',
                sending_interval: 2,
              },false),
             investorsForm: new Form({
                investors: []
              }),
              name:'',
              message:'',
              message_1:'',
              message_2:'',
              message_3:'',
              message_4:'',
              message_5:'',
              messages:[],
              investors: [],
              is_loaded: false,
              cur_slide: 0,
              cur_message_name: '',
              is_confirmed: false,
              is_started: false,
              view: 'emails'
            };
        },
        mounted(){
            this.messages[0] = {};
            this.messages[1] = {};
            this.messages[2] = {};
            this.messages[3] = {};
            this.messages[4] = {};
            this.getInvestors();
            this.getUserCampaign();
            this.getUser();
        },
        methods: {
          onSlidePrev(slide){
              console.log("Prev");
              if(this.cur_slide==0){
                this.cur_slide = 4;
              }else{
                this.cur_slide--;
              }
              this.cur_message_name = this.messages[this.cur_slide].name;
          },
          onSlideNext(slide){
            console.log("Next");
            if(this.cur_slide==4){
              this.cur_slide = 0;
            }else{
              this.cur_slide++;
            }
            this.cur_message_name = this.messages[this.cur_slide].name;
          },
          onSlide(slide){
            this.cur_slide = slide;
            console.log("Slide: " + slide);
            this.cur_message_name = this.messages[slide].name;
          },
            showMessage(id){
              axios.get('/api/user/investor-messages-campaign/'+this.id+'/'+id)
                  .then(response => response.data)
                  .then(response => {
                    this.messages = response.messages;
                    this.cur_message_name = this.messages[0].name;
                    $('#modalMessage').modal();
                  })
                  .catch(error => {
                    helper.showDataErrorMsg(error);
                  })
            },
          getEmailTemplates(){
            axios.get('/api/email-template/6')
                .then(response => response.data)
                .then(response => {
                  this.templateForm.message_1_subject = response.email_template.subject;
                  this.templateForm.message_1_body = response.email_template.body;
                })
                .catch(error => {
                  helper.showDataErrorMsg(error);
                  this.$router.push('/account/email-template');
                })

            axios.get('/api/email-template/7')
                .then(response => response.data)
                .then(response => {
                  this.templateForm.message_2_subject = response.email_template.subject;
                  this.templateForm.message_2_body = response.email_template.body;
                })
                .catch(error => {
                  helper.showDataErrorMsg(error);
                  this.$router.push('/account/email-template');
                })

            axios.get('/api/email-template/8')
                .then(response => response.data)
                .then(response => {
                  this.templateForm.message_3_subject = response.email_template.subject;
                  this.templateForm.message_3_body = response.email_template.body;
                })
                .catch(error => {
                  helper.showDataErrorMsg(error);
                  this.$router.push('/account/email-template');
                })

            axios.get('/api/email-template/9')
                .then(response => response.data)
                .then(response => {
                  this.templateForm.message_4_subject = response.email_template.subject;
                  this.templateForm.message_4_body = response.email_template.body;
                })
                .catch(error => {
                  helper.showDataErrorMsg(error);
                  this.$router.push('/account/email-template');
                })

            axios.get('/api/email-template/10')
                .then(response => response.data)
                .then(response => {
                  this.templateForm.message_5_subject = response.email_template.subject;
                  this.templateForm.message_5_body = response.email_template.body;
                  this.is_loaded = true;
                })
                .catch(error => {
                  helper.showDataErrorMsg(error);
                  this.$router.push('/account/email-template');
                })

          },
          getInvestors(){
            axios.get('/api/investors/'+this.id)
                .then(response => response.data)
                .then(response => {
                  this.investors = response;
                })
                .catch(error => {
                  helper.showDataErrorMsg(error)
                });
          },
          saveUserCampaign(){
            this.templateForm.user_id = this.id;
            this.templateForm.patch('/api/user-campaign/'+this.id)
                .then(response => {
                  toastr.success(response.message);
                  if(this.view=='emails'){
                    this.view='settings';
                  }else{
                    this.view='investors';
                  }
                })
                .catch(error => {
                  helper.showErrorMsg(error);
                });
          },
          saveUserCampaignInvestors(){
            this.investorsForm.investors = [];

            this.investors.forEach(function (item) {
              if(item.pivot.is_deactive == 1){
                this.investorsForm.investors.push(item.id);
              }
            }.bind(this));

            this.investorsForm.post('/api/user-campaign-investors/'+this.id)
                .then(response => {
                  toastr.success(response.message);
                  this.is_started = true;
                })
                .catch(error => {
                  helper.showErrorMsg(error);
                });
          },
          updateInvestorStatus(id,status){
            for (var index in this.investors) {
              if(this.investors[index].id==id){
                if(status==2){
                  this.investors[index].pivot.is_deactive = 1;
                }  else{
                  this.investors[index].pivot.is_deactive = 2;
                }
              }
            }
          },
          getUserCampaign(){
            axios.get('/api/user-campaign/'+this.id)
                .then(response => response.data)
                .then(response => {
                  if(response.status==1){
                    this.is_started = true;
                  }else {
                    if (!response.message_1_subject) {
                      this.getEmailTemplates();
                    } else {

                      this.templateForm.message_1_subject = response.message_1_subject;
                      this.templateForm.message_1_body = response.message_1_body;
                      this.templateForm.message_2_subject = response.message_2_subject;
                      this.templateForm.message_2_body = response.message_2_body;
                      this.templateForm.message_3_subject = response.message_3_subject;
                      this.templateForm.message_3_body = response.message_3_body;
                      this.templateForm.message_4_subject = response.message_4_subject;
                      this.templateForm.message_4_body = response.message_4_body;
                      this.templateForm.message_5_subject = response.message_5_subject;
                      this.templateForm.message_5_body = response.message_5_body;
                      this.is_loaded = true;
                    }
                  }
                })
                .catch(error => {
                  helper.showDataErrorMsg(error)
                });
          },
            getUser(){
                axios.get('/api/user/'+this.id)
                    .then(response => response.data)
                    .then(response => {
                        this.user = response.user;
                        if(response.user.profile.questionnaire_step > 3){
                          this.is_confirmed = true;
                        }else{
                          this.is_confirmed = false;
                        }
                    })
                    .catch(error => {
                        helper.showDataErrorMsg(error);
                    })
            },
        },
        watch: {

        },
        filters: {

        }
    }
</script>
<style>
.modal-body{
  padding:40px 40px 60px;
}
.carousel-control-prev {
  left: -30px;
}
.carousel-control-next {
  right: -30px;
}
.carousel-control-prev, .carousel-control-next{
  width:20px;
}
.carousel-control-next-icon {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23000' viewBox='0 0 8 8'%3e%3cpath d='M2.75 0l-1.5 1.5 2.5 2.5-2.5 2.5 1.5 1.5 4-4-4-4z'/%3e%3c/svg%3e")!important;
}
.carousel-control-prev-icon {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23000' viewBox='0 0 8 8'%3e%3cpath d='M5.25 0l-4 4 4 4 1.5-1.5-2.5-2.5 2.5-2.5-1.5-1.5z'/%3e%3c/svg%3e")!important;
}
.carousel-indicators li {
  background-color: #000;
}
.carousel-indicators {
  bottom: -50px;
  margin-bottom: 0;
}
ul.pta-campaign-steps{
    list-style: none;
    margin-bottom:20px;
    margin-top:-20px;
    padding-left:0;
}
ul.pta-campaign-steps li{
  display:inline-block;
  background:#fff;
  border-radius:10px;
  margin-right:30px;
  padding:5px 20px;
  font-size:14px;
  position: relative;
}
ul.pta-campaign-steps li.active{
  background:#343434;
  color:#fff;
}
ul.pta-campaign-steps li:after{
  content:'';
  height:1px;
  background:#343434;
  width:20px;
  position:absolute;
  right:-27px;
  top:16px;
}
ul.pta-campaign-steps li:last-child:after{
  display:none;
}
</style>
